export default __webpack_public_path__ + "static/media/sokoj-background.2622f149.jpg";